import React from "react";
import styled from "styled-components";

const Card = () => {
  return (
    <StyledWrapper>
      <div className="CodeCard">
        <div className="CodeCardHeader">
          <span className="red"></span>
          <span className="yellow"></span>
          <span className="green"></span>
        </div>

        <div className="CodeCardContent">
          <p>
            <code>
              <span className="c5">aser</span> ={" "}
              <span className="c6">Agent</span>(
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span className="c1">name</span>=
              <span className="c2">"aser"</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span className="c1">model</span>=
              <span className="c2">"gpt-4o-mini"</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span className="c1">tools</span>=<span className="c3">[</span>
              <span className="c4">web3bio</span>,{" "}
              <span className="c4">exa</span>
              <span className="c3">]</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span className="c1">knowledge</span>=
              <span className="c4">knowledge</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span className="c1">memory</span>=
              <span className="c4">memory</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span className="c1">chat2web3</span>=
              <span className="c3">[</span>
              <span className="c4">connector</span>
              <span className="c3">]</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span className="c1">mcp</span>=
              <span className="c3">[</span>
              <span className="c4">price</span>
              <span className="c3">]</span>,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;<span className="c1">trace</span>=
              <span className="c4">trace</span>
              <br />)
            </code>
          </p>
        </div>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .CodeCard {
    height: auto;
    background: #000;
    border-radius: 10px;
    border: 1px #333 solid;
    overflow: hidden;
  }
  .CodeCardHeader {
    height: auto;
    background: #202425;
    padding: 10px 12px;
  }
  .CodeCardHeader span {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .CodeCardHeader .red {
    background-color: #ff5f57;
  }

  .CodeCardHeader .yellow {
    background-color: #ffbd2e;
  }

  .CodeCardHeader .green {
    background-color: #28c941;
  }

  .CodeCardContent {
    color: #8e8e8e;
    line-height: 20px;
    padding: 20px;
  }

  .c1 {
    color: #4380ff;
  }

  .c4 {
    color: #23ff00;
  }

  .c3 {
    color: #e600ff;
  }

  .c2 {
    color: #ffaf01;
  }

  .c5 {
    color: #4ec9b0;
  }

  .c6 {
    color: #ffffff;
  }

  .CodeCardTop {
    color: #fff;
    width: 100%;
    text-align: left;
    border-radius: 10px;
    height: 40px;
    line-height: 40px;
  }
`;

export default Card;
